import { sendPasswordResetEmail } from "firebase/auth";
import { useState } from "react";
import { auth } from "../../firebase";

export default function ForgotPasswordEmailModal({setModal}) {
    const [email, setEmail] = useState("")
    const [emailSent, setEmailSent] = useState(false)
    const [error, setError] = useState("")

    const handleResetPasswordSubmit = (e) => {
        e.preventDefault()
        setError("")
        sendPasswordResetEmail(auth, email).then(() => {
            setEmailSent(true)
        })
        .catch((error) => {
            console.log(error.code)
            setError(error.message)
        });
    }

    return <div className="modal-overlay" onClick={() => setModal(false)}>
        <div className="add-card-modal" onClick={(e) => e.stopPropagation()}> 
            <form onSubmit={(e) => handleResetPasswordSubmit(e)}>
                <input type="email" onChange={(e) => setEmail(e.target.value)} placeholder="Enter email address" required />
                <input type="submit" value="Send password reset email" className="cta" />
            </form>

            {error != "" && <div className="error-field"> {error} </div>}

            {emailSent && <>
                <p> Email sent, check your SPAM.</p>
                <p> The subject is "Reset your password for optcg-binder" sent by noreply@optcg-binder.firebaseapp.com </p>
            </>}
        </div>
    </div>
}